import React from 'react';
import PropTypes from 'prop-types';

const VideoModal = ({ video, className }) => (
  <div className="video-modal">
    <iframe width="100%" height="315" className={className} frameBorder={0} src={`https://www.youtube.com/embed/${video.video}?autoplay=${video.autoplay}&modestbranding=true`} />
  </div>
);

VideoModal.propTypes = {
  video: PropTypes.shape({}),
  className: PropTypes.string
};

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/common/ui/VideoModal.jsx